<div class="row mt-3 mb-5 mx-3 mx-md-0">
  <div class="col-12 col-md-10 offset-md-1 justify-content-center">
    <mat-card class="rounded-0 border">
      <mat-card-title>
        <h2 class="color-blue-cat">Mi Perfil</h2>
      </mat-card-title>
      <mat-card-content>
        <mat-tab-group
          (selectedTabChange)="onChange($event)"
          *ngIf="userTypeId !== 5"
        >
          <mat-tab>
            <ng-template mat-tab-label>
              <mat-icon class="tab-icon">account_box</mat-icon>Datos
              Generales</ng-template
            >
            <app-form-datos-generales></app-form-datos-generales>
          </mat-tab>

          <mat-tab>
            <ng-template mat-tab-label>
              <mat-icon class="tab-icon">account_box</mat-icon>Otros
              Datos</ng-template
            >
            <app-form-otros-datos></app-form-otros-datos>
          </mat-tab>

          <mat-tab>
            <ng-template mat-tab-label>
              <mat-icon class="tab-icon">topic</mat-icon>Requisitos</ng-template
            >
            <app-requisitos></app-requisitos>
          </mat-tab>

          <mat-tab>
            <ng-template mat-tab-label>
              <mat-icon class="tab-icon">military_tech</mat-icon>Mis
              Certificaciones</ng-template
            >
            <app-certificaciones></app-certificaciones>
          </mat-tab>

          <mat-tab>
            <ng-template mat-tab-label>
              <mat-icon class="tab-icon">engineering</mat-icon>Mis
              Proyectos</ng-template
            >
          </mat-tab>
        </mat-tab-group>

        <mat-tab-group *ngIf="userTypeId === 5">
          <mat-tab>
            <ng-template mat-tab-label>
              <mat-icon class="tab-icon">account_box</mat-icon>Datos
              Generales</ng-template
            >
            <app-form-datos-generales-patrons></app-form-datos-generales-patrons>
          </mat-tab>
        </mat-tab-group>
      </mat-card-content>
    </mat-card>
  </div>
</div>
